<template>
  <b-overlay
    :show="isLoading"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
  >
    <div>
      <b-modal
        id="ModalImportExcel"
        ref="ModalImportExcel"
        centered
        hide-footer
        :title="modalTitle"
      >
        <div
          class="upload-section mb-2 d-flex justify-content-center align-items-center flex-column cursor-pointer"
        >
          <div
            @click="handleTrigger"
            class="d-flex flex-column align-items-center cs-upload w-full"
          >
            <svg height="100" width="100" viewBox="0 0 24 24">
              <path
                d="M18.4199 8.2199C17.8089 6.8159 16.7544 5.65097 15.418 4.90362C14.0815 4.15627 12.5369 3.86773 11.0209 4.0822C9.50477 4.29668 8.10082 5.00235 7.02415 6.09107C5.94747 7.17979 5.25748 8.59151 5.05989 10.1099C4.10648 10.3382 3.27011 10.9087 2.70963 11.7131C2.14914 12.5174 1.90357 13.4996 2.01955 14.4731C2.13553 15.4466 2.60498 16.3436 3.33876 16.9938C4.07253 17.6439 5.01952 18.002 5.99989 17.9999C6.26511 17.9999 6.51946 17.8945 6.707 17.707C6.89453 17.5195 6.99989 17.2651 6.99989 16.9999C6.99989 16.7347 6.89453 16.4803 6.707 16.2928C6.51946 16.1053 6.26511 15.9999 5.99989 15.9999C5.46946 15.9999 4.96075 15.7892 4.58568 15.4141C4.2106 15.039 3.99989 14.5303 3.99989 13.9999C3.99989 13.4695 4.2106 12.9608 4.58568 12.5857C4.96075 12.2106 5.46946 11.9999 5.99989 11.9999C6.26511 11.9999 6.51946 11.8945 6.707 11.707C6.89453 11.5195 6.99989 11.2651 6.99989 10.9999C7.00244 9.81717 7.42418 8.67365 8.19016 7.77248C8.95614 6.87131 10.0168 6.27085 11.1836 6.07777C12.3505 5.88469 13.548 6.1115 14.5635 6.7179C15.5789 7.32431 16.3465 8.27104 16.7299 9.3899C16.7871 9.56174 16.8898 9.71483 17.0272 9.83283C17.1646 9.95083 17.3314 10.0293 17.5099 10.0599C18.176 10.1858 18.7798 10.5335 19.2229 11.0464C19.6661 11.5594 19.9225 12.2073 19.9503 12.8845C19.9781 13.5618 19.7758 14.2286 19.3762 14.7761C18.9766 15.3237 18.4034 15.7198 17.7499 15.8999C17.4926 15.9662 17.2722 16.132 17.1372 16.3608C17.0022 16.5896 16.9636 16.8626 17.0299 17.1199C17.0962 17.3772 17.262 17.5975 17.4908 17.7326C17.7196 17.8676 17.9926 17.9062 18.2499 17.8399C19.3023 17.5618 20.2352 16.9479 20.9069 16.0914C21.5786 15.2348 21.9525 14.1825 21.9717 13.0942C21.991 12.0058 21.6545 10.9409 21.0135 10.0612C20.3724 9.18149 19.4618 8.53499 18.4199 8.2199ZM12.7099 10.2899C12.6148 10.1989 12.5026 10.1275 12.3799 10.0799C12.1364 9.97988 11.8634 9.97988 11.6199 10.0799C11.4971 10.1275 11.385 10.1989 11.2899 10.2899L8.28989 13.2899C8.10159 13.4782 7.9958 13.7336 7.9958 13.9999C7.9958 14.2662 8.10159 14.5216 8.28989 14.7099C8.47819 14.8982 8.73359 15.004 8.99989 15.004C9.26619 15.004 9.52159 14.8982 9.70989 14.7099L10.9999 13.4099V18.9999C10.9999 19.2651 11.1052 19.5195 11.2928 19.707C11.4803 19.8945 11.7347 19.9999 11.9999 19.9999C12.2651 19.9999 12.5195 19.8945 12.707 19.707C12.8945 19.5195 12.9999 19.2651 12.9999 18.9999V13.4099L14.2899 14.7099C14.3829 14.8036 14.4935 14.878 14.6153 14.9288C14.7372 14.9796 14.8679 15.0057 14.9999 15.0057C15.1319 15.0057 15.2626 14.9796 15.3845 14.9288C15.5063 14.878 15.6169 14.8036 15.7099 14.7099C15.8036 14.6169 15.878 14.5063 15.9288 14.3845C15.9796 14.2626 16.0057 14.1319 16.0057 13.9999C16.0057 13.8679 15.9796 13.7372 15.9288 13.6153C15.878 13.4935 15.8036 13.3829 15.7099 13.2899L12.7099 10.2899Z"
                fill="#4c95eb"
              />
            </svg>
            <p class="description">Tải lên tệp</p>
            <p class="support">Định dạng hỗ trợ: .xlsx, .xls</p>
          </div>
          <slot name="link-example"></slot>
        </div>
        <b-form-file
          ref="UploadMedicine"
          v-model="file"
          placeholder="Tải lên tệp..."
          accept=".xlsx, .xls"
          no-drop
          browse-text="Chọn tệp"
          class="cs-select-file"
          :state="!message.error"
        />
        <small v-if="message.error" class="text-danger">{{ message.error }}</small>
        <slot></slot>

        <b-button
          @click="handleSubmit"
          :disabled="!file"
          variant="primary"
          class="w-full mt-3"
        >Tải lên</b-button>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import appUtils from "@/utils/appUtils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Excel from "exceljs";

export default {
  name: "ModalImportExcel",
  components: {},
  props: {
    modalTitle: String,
    indexStartTable: Number
  },
  data() {
    return {
      isLoading: false,
      file: null,
      fileData: [],
      message: {
        success: null,
        error: null
      }
    };
  },

  computed: {
    isDisableUploadBtn() {
      return !this.patientList.length && !this.file;
    }
  },
  methods: {
    handleTrigger() {
      this.$refs.UploadMedicine.$refs.input.click();
    },
    convertExcelDateToJsDate(date) {
      return new Date(Math.round((date - 25569) * 86400 * 1000));
    },
    validateUpload(file) {
      const isXLSX = ["xlsx", "xls"].includes(
        file.name.split(".")[file.name.split(".").length - 1]
      );

      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isXLSX) {
        this.message.error = "Vui lòng chọn tệp đúng định dạng excel!";
      }
      if (!isLt2M) {
        this.message.error =
          "Vui lòng chọn tệp có dung lượng không vượt quá 20MB!";
      }
      return isXLSX && isLt2M;
    },
    async handleSubmit() {
      const isValid = this.validateUpload(this.file);
      if (!isValid) return;
      await this.handleReadFileData();
    },
    async handleReadFileData() {
      try {
        this.isLoading = true;

        const wb = new Excel.Workbook();
        const reader = new FileReader();
        const dataList = [];
        const self = this;

        reader.readAsArrayBuffer(self.file);
        reader.onload = async () => {
          const buffer = reader.result;
          await wb.xlsx
            .load(buffer)
            .then(workbook => {
              workbook.eachSheet(sheet => {
                sheet.eachRow(row => {
                  dataList.push(row.values);
                });
              });

              return dataList;
            })
            .then(result => {
              self.handleRawFileData(result);
            });
        };
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi tải tệp lên",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    },
    async handleRawFileData(fileData) {
      try {
        const keys = fileData?.[this.indexStartTable || 0];
        const formatKeys = keys.map(item => {
          const rawKey = appUtils.toNonAccentVietnamese(item.toString());
          return appUtils.toSnakeCase(rawKey);
        });
        const dataList = fileData?.slice(this.indexStartTable + 1 || 1);

        // Map key and value
        const rawData = dataList.map(data => {
          const dataObject = {};

          formatKeys.forEach((key, index) => {
            if (data[index]?.richText) {
              const parseData = appUtils.richToString(data[index]);
              dataObject[key] = parseData;
            } else {
              dataObject[key] = data[index];
            }
          });
          return dataObject;
        });

        await this.handleUploadData(rawData);
      } catch (error) {
        this.isLoading = false;

        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi tải tệp lên",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    },
    async handleUploadData(resultData) {
      try {
        this.$emit("onUpload", resultData);
      } catch (error) {
        this.isLoading = false;

        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi tải tệp lên",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    },
    onClose() {
      this.isLoading = false;
      this.$refs["ModalImportExcel"].toggle("#toggle-btn");
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-section {
  background-color: #eef6ff;
  border: dashed 2px #2774cf;
  padding-top: 20px;
  padding-bottom: 15px;
  .description {
    font-weight: 700;
    font-size: 18px;
    height: 26px;
    line-height: 26px;
    margin-top: 10px;
  }
  .support {
    font-weight: 400;
    font-size: 13px;
    height: 20px;
    line-height: 20px;
    color: #676767;
  }
  .link {
    color: #4c95eb;
    text-decoration: underline;
    cursor: pointer;
  }
  ::v-deep .el-upload-dragger {
    background-color: transparent;
    border: none;
    height: auto;
  }
}
.upload-line {
  display: block;
  ::v-deep .el-upload {
    display: block;
    .upload-container {
      height: 40px;
      border: 1px solid #11af22;
      border-radius: 4px;
      padding: 5px 10px;
      justify-content: flex-start;
    }
  }
}
.file-uploaded {
  margin-bottom: 30px;
  height: 40px;
  border: 1px solid #11af22;
  border-radius: 4px;
  padding: 5px 10px;
  justify-content: flex-start;
  cursor: auto;
  position: relative;
  svg {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    right: 0;
    transform: translate(-50%);
  }
}
.send-data {
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: calc(100% - 40px);
  background: #476dd6;
  border-color: #476dd6;
}
::v-deep {
  .el-dialog__header {
    font-weight: 700;
    font-size: 24px;
    color: #0f0f0f;
  }
  .el-dialog__body {
    padding-top: 0px;
  }
  .select-cs {
    .el-input__inner {
      height: 32px !important;
    }
  }
}
.error-message {
  color: red;
  margin: 0px 20px 5px;
  word-break: break-word;
}

.cs-select-file ::v-deep * {
  font-size: 14px !important;
}
</style>
  